<template>
    <main>
        <section class="slogan">
            <div class="container1366 hero-wrapper">
                <div class="hero-text-wrapper hero-text-wrapper1">
                    <div class="hero-title">{{ $t('lp-collections01') }}<div>{{ $t('lp-collections02') }}</div></div>
                    <div class="hero-text">{{ $t('lp-collections28') }}</div>
                    <div v-on:click="scrollToTop" class="hero-btn ga4-reg-btn">{{ $t("lp-collections29") }}</div>
                </div>
                <div class="hero-text-wrapper"></div>
            </div>
            <div class="container1366 slogan-bullets">
                <div class="why-vindome-wrapper">
                    <v-row>
                        <v-col class="why-vindome-col">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
                                        <rect x="8.3335" y="60" width="10" height="12" fill="#907D4C"/>
                                        <rect x="26.3335" y="44" width="10" height="28" fill="#907D4C"/>
                                        <rect x="44.3335" y="28" width="10" height="44" fill="#907D4C"/>
                                        <rect x="62.3335" y="8" width="10" height="64" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('lp-collections31') }}</div>
                                <div class="card-text">{{ $t('lp-collections32') }}</div>
                            </div>
                        </v-col>
                        <v-col class="why-vindome-col why-vindome-col-2">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M40 8L14 19.6364V37.0909C14 53.2364 25.0933 68.3345 40 72C54.9067 68.3345 66 53.2364 66 37.0909V19.6364L40 8ZM34.2222 54.5455L22.6667 42.9091L26.74 38.8073L34.2222 46.3127L53.26 27.1418L57.3333 31.2727L34.2222 54.5455Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('home2') }}</div>
                                <div class="card-text">{{ $t('lp-collections30') }}</div>
                            </div>
                        </v-col>
                        <v-col class="why-vindome-col">
                            <div class="how-icon">
                                <div class="card-icon">
                                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9989 8.00049C38.116 8.00064 36.4322 9.03315 35.0207 10.6092C34.6649 10.5304 34.3014 10.4906 33.9366 10.4906C33.9121 10.4904 33.8875 10.4904 33.863 10.4906C31.1746 10.5306 29.0165 12.6769 29.0163 15.3109C29.0171 16.716 29.6436 18.0509 30.7318 18.9662C30.3624 20.1011 29.9958 21.2405 29.6898 22.508C28.0023 22.0126 26.3802 21.6212 24.8484 21.3377C21.7912 20.7718 19.0828 20.629 16.8337 21.0026C14.5847 21.3762 12.705 22.3156 11.7134 23.9979V24.0031C10.722 25.6856 10.8296 27.7492 11.6239 29.8442C12.4182 31.9392 13.8945 34.1633 15.9233 36.4741C16.9405 37.6327 18.0976 38.8154 19.3808 40.0005C18.0976 41.1856 16.9405 42.3683 15.9233 43.5268C13.8945 45.8377 12.4182 48.0618 11.6239 50.1568C10.8296 52.2517 10.722 54.3154 11.7134 55.9979C12.705 57.6802 14.5847 58.6248 16.8337 58.9984C17.1791 59.0557 17.5564 59.0784 17.9231 59.1118C18.6314 61.0161 20.4799 62.2831 22.5487 62.2824C25.0393 62.2809 27.1361 60.4569 27.4323 58.0343C28.1881 57.8478 28.9031 57.719 29.6898 57.4878C30.0959 59.1693 30.5634 60.7418 31.0791 62.1845C32.1075 65.0612 33.3344 67.4281 34.7891 69.1495C36.2439 70.8709 38.016 72.0003 39.9989 72.0005C41.9819 72.0003 43.754 70.8709 45.2088 69.1495C46.6635 67.4281 47.8904 65.0612 48.9188 62.1845C49.4345 60.7418 49.902 59.1693 50.308 57.4878C51.9961 57.9837 53.6174 58.3796 55.1495 58.6633C58.2072 59.2294 60.9094 59.3719 63.1589 58.9984C65.4084 58.6249 67.2927 57.6805 68.2845 55.9979C69.276 54.3152 69.1685 52.2468 68.374 50.1516C68.2229 49.7534 68.0263 49.3473 67.8267 48.9401C68.3946 48.1355 68.6992 47.1807 68.7002 46.2025C68.6996 43.5405 66.4971 41.3827 63.7799 41.3822C63.7553 41.382 63.7307 41.382 63.7062 41.3822C63.1997 41.389 62.6974 41.4725 62.2169 41.6296C61.6774 41.0832 61.207 40.545 60.6119 39.9953C61.894 38.8114 63.0526 37.6373 64.0693 36.4793C66.0986 34.1682 67.5794 31.9394 68.374 29.8442C69.1685 27.749 69.276 25.6858 68.2845 24.0031V23.9979C67.2927 22.3154 65.4084 21.3761 63.1589 21.0026C60.9094 20.6291 58.2072 20.7715 55.1495 21.3377C53.6174 21.6214 51.9961 22.0173 50.308 22.5131C49.9019 20.8317 49.4345 19.2594 48.9188 17.8165C47.8904 14.9392 46.6637 12.5681 45.2088 10.8463C43.7539 9.12456 41.9822 8.00064 39.9989 8.00049ZM39.9989 10.3462C41.0587 10.3463 42.1851 10.948 43.3669 12.3465C44.5487 13.7451 45.6956 15.8881 46.6612 18.5898C47.1683 20.0086 47.6237 21.5946 48.0242 23.2916C45.4434 24.1585 42.771 25.1921 39.9989 26.4932C37.2284 25.1931 34.5584 24.1527 31.979 23.2865C32.2522 22.1311 32.5575 21.0527 32.8789 20.0179C33.2262 20.093 33.5809 20.1311 33.9366 20.1313C36.6538 20.1307 38.8564 17.9729 38.857 15.3109C38.8548 13.9458 38.2619 12.6457 37.2256 11.733C38.1905 10.7927 39.1194 10.3463 39.9989 10.3462ZM18.7229 23.1679C20.3229 23.092 22.2481 23.2437 24.4011 23.6422C25.9085 23.9212 27.5368 24.3351 29.2373 24.8434C28.7146 27.4637 28.2989 30.2478 28.0638 33.2468C25.5273 34.9484 23.2745 36.6974 21.2173 38.4539C19.9166 37.2648 18.74 36.0884 17.7389 34.9481C15.8338 32.7783 14.5109 30.7313 13.8657 29.0297C13.2206 27.328 13.2518 26.0724 13.7815 25.1734C14.3114 24.2744 15.4069 23.6208 17.2337 23.3174C17.6904 23.2415 18.1896 23.1932 18.7229 23.1679ZM59.5647 23.1679C60.7692 23.1152 61.8454 23.1657 62.759 23.3174C64.5861 23.6208 65.6811 24.2743 66.2111 25.1734C66.7409 26.0725 66.7723 27.3277 66.1269 29.0297C65.4815 30.7316 64.1593 32.778 62.2538 34.9481C61.2537 36.087 60.0791 37.2608 58.7806 38.4487C56.7245 36.6928 54.4693 34.9479 51.9341 33.2468C51.6982 30.248 51.2842 27.4636 50.7606 24.8434C52.4594 24.3353 54.0852 23.9211 55.5915 23.6422C57.0271 23.3764 58.3601 23.2206 59.5647 23.1679ZM31.5264 25.6219C33.3801 26.2561 35.2894 27.0083 37.2677 27.88C36.143 28.4559 35.0228 28.9968 33.8893 29.638C32.7556 30.2792 31.7192 30.9615 30.6476 31.628C30.8663 29.5118 31.1598 27.5131 31.5264 25.6219ZM48.4715 25.6219C48.8371 27.5117 49.1323 29.5084 49.3503 31.6229C48.2775 30.9556 47.2385 30.2748 46.1034 29.6328C44.9716 28.9927 43.8531 28.4549 42.7301 27.88C44.7081 27.008 46.6182 26.2564 48.4715 25.6219ZM39.9989 29.1121C41.6218 29.8994 43.2609 30.7321 44.9088 31.6641C46.5574 32.5965 48.1161 33.5676 49.6239 34.5512C49.7393 36.3243 49.8187 38.1332 49.8186 40.0005C49.8186 41.8675 49.7394 43.6767 49.6239 45.4498C48.1161 46.4334 46.5574 47.4045 44.9088 48.3369C43.2609 49.2689 41.6218 50.1015 39.9989 50.8888C38.3741 50.1003 36.734 49.2652 35.0838 48.3317C33.4355 47.3994 31.8765 46.4278 30.3687 45.4447C30.2531 43.6731 30.174 41.8657 30.174 40.0005C30.1739 38.135 30.2531 36.3279 30.3687 34.5563C31.8765 33.5731 33.4355 32.6016 35.0838 31.6693C36.734 30.7358 38.3741 29.9007 39.9989 29.1121ZM39.7674 33.109C35.9432 33.109 32.8171 36.1716 32.8171 39.918C32.8171 43.6644 35.9432 46.727 39.7674 46.727C43.5916 46.727 46.7177 43.6644 46.7177 39.918C46.7177 36.1716 43.5916 33.109 39.7674 33.109ZM27.9217 36.2525C27.8684 37.4958 27.7848 38.7168 27.7848 40.0005C27.7849 41.284 27.8682 42.5052 27.9217 43.7485C26.1591 42.5048 24.5382 41.2573 23.0487 40.0005C24.5382 38.7437 26.1591 37.4962 27.9217 36.2525H27.9217ZM52.0762 36.2525C53.8369 37.4958 55.4559 38.7441 56.944 40.0005C55.4559 41.2569 53.8369 42.5052 52.0762 43.7485C52.1297 42.5052 52.213 41.284 52.213 40.0005C52.2131 38.7168 52.1296 37.4958 52.0762 36.2525ZM21.2173 41.5471C23.2745 43.3036 25.5273 45.0526 28.0638 46.7542C28.2997 49.753 28.7138 52.5372 29.2373 55.1576C28.5218 55.3714 27.8291 55.5576 27.1428 55.735C26.4126 53.8717 24.586 52.6418 22.5487 52.6417C22.5224 52.6415 22.4961 52.6415 22.4698 52.6417C20.0693 52.6778 18.0458 54.4054 17.681 56.73C17.5366 56.7117 17.3709 56.7064 17.2337 56.6836C15.4069 56.3802 14.3114 55.7266 13.7815 54.8276C13.2518 53.9286 13.2206 52.673 13.8657 50.9713C14.5109 49.2697 15.8338 47.2227 17.7389 45.0529C18.74 43.9126 19.9166 42.7362 21.2173 41.5471ZM58.7753 41.5471C59.2733 42.0026 59.7374 42.4528 60.1962 42.903C59.3385 43.7963 58.8605 44.9762 58.8595 46.2025C58.8601 48.8645 61.0627 51.0223 63.7799 51.0229C64.5237 51.0224 65.2578 50.8567 65.9269 50.5383C65.9882 50.6809 66.0745 50.8331 66.1269 50.9713C66.7723 52.6733 66.7409 53.9284 66.2111 54.8276C65.6812 55.7267 64.5861 56.3802 62.759 56.6836C60.9318 56.987 58.4627 56.8904 55.5915 56.3588C54.0852 56.0799 52.4594 55.6657 50.7606 55.1576C51.2844 52.5357 51.6982 49.7498 51.9341 46.749C54.4681 45.0495 56.72 43.3013 58.7753 41.5471H58.7753ZM30.6476 48.373C31.7192 49.0395 32.7556 49.7218 33.8893 50.363C35.0228 51.0042 36.143 51.5451 37.2677 52.121C35.2894 52.9927 33.3801 53.7449 31.5264 54.3791C31.1598 52.4877 30.8663 50.4892 30.6476 48.373ZM49.3503 48.373C49.1322 50.4894 48.8374 52.4876 48.4715 54.3791C46.6168 53.7441 44.7044 52.9938 42.7249 52.121C43.8499 51.5449 44.9695 51.0043 46.1034 50.363C47.2385 49.721 48.2775 49.0401 49.3503 48.373ZM39.9884 53.5027C42.7643 54.806 45.44 55.8414 48.0242 56.7094C47.6237 58.4064 47.1683 59.9926 46.6612 61.4112C45.6956 64.1123 44.5485 66.2562 43.3669 67.6544C42.1853 69.0526 41.0586 69.6547 39.9989 69.6548C38.9393 69.6547 37.8126 69.0526 36.631 67.6544C35.4493 66.2562 34.3023 64.1123 33.3367 61.4112C32.8296 59.9926 32.3747 58.4064 31.9737 56.7094C34.5518 55.8429 37.2193 54.8025 39.9884 53.5027Z" fill="#907D4C"/>
                                    </svg>
                                </div>
                                <div class="card-title">{{ $t('home4') }}</div>
                                <div class="card-text">{{ $t('lp-collections33') }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </section>

        <section id="top-collections">
            <div class="container1366 padding120 padding80" ref="topCollectionsRef">
                <h2 class="home-title">{{ $t('lp-collections09') }}<span>{{ $t('lp-collections11') }}</span></h2>
                <div class="home-subtitle">{{ $t('lp-collections34') }}</div>
                <HomeTopCollectionsCarousel class="home-collections-container" :collections-list="topCollectionItems"></HomeTopCollectionsCarousel>
            </div>
        </section>

        <section id="authenticity">
            <div class="container1366 padding80">
                <div class="auth-text-wrapper">
                    <div class="auth-text-inner">
                        <h2 class="home-title home-title2">{{ $t('lp-collections35') }} <span>{{ $t('lp-collections36') }}</span></h2>
                        <div class="home-subtitle home-subtitle2">{{ $t('lp-collections37') }}</div>
                    </div>
                </div>
                <div class="auth-text-wrapper"></div>
            </div>
        </section>

        <section id="more-collections">
            <div class="container1366 padding120 padding80 more-collections-container" ref="allCollectionsRef">
                <h2 class="home-title">{{ $t('lp-collections10') }}<span>{{ $t('lp-collections11') }}</span></h2>
                <div class="home-subtitle">{{ $t('lp-collections27') }}</div>
                <HomeMoreCollections class="home-more-collections" :useSlider="false" :collections-list="restCollectionsItems"></HomeMoreCollections>
            </div>
        </section>

        <section class="investor5">
            <div class="container1366 padding120 padding80">
                <div class="investor5-left">
                    <div class="investor5-left-title">{{ $t("lp-collections22") }} <span>{{ $t("lp-collections23") }}</span></div>
                    <div class="investor5-left-text">{{ $t("lp-collections24") }}</div>
                    <nuxt-link v-if="!isLogged" :to="localePath('/login')" class="home-section2-btn2">{{ $t("new-home11") }}</nuxt-link>
                    <div v-if="isLogged" v-on:click="scrollToAll" class="home-section2-btn2">{{ $t("new-home11") }}</div>
                </div>
                <div class="investor5-right">
                    <div class="investor5-right-row1">
                        <div class="investor5-right-item item1">
                            <div class="investor5-right-item-title">100+</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector33") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector34") }}</div>
                        </div>
                        <div class="investor5-right-item item2">
                            <div class="investor5-right-item-title">20+%</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector35") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector36") }}</div>
                        </div>
                    </div>
                    <div class="investor5-right-row2">
                        <div class="investor5-right-item item3">
                            <div class="investor5-right-item-title">35,000+</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector37") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector38") }}</div>
                        </div>
                        <div class="investor5-right-item item4">
                            <div class="investor5-right-item-title">€ 1,300</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector39") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector40") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import { mapGetters } from "vuex";
import HomeMoreCollections from "../components/home/HomeMoreCollections";
import HomeTopCollectionsCarousel from "@/components/home/HomeTopCollectionsCarousel";
import {GOrders, GUser} from "@/store/getters";
import {AOrders} from "@/store/actions";
import {GCommon} from "@/store/getters";

export default {
    name: 'LPWineCollectionsInvestor3',
    head: {
        title: 'Fine Wine Collections for Investors | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'collections-page-investors'
        }
    },
    components: {
        HomeMoreCollections, HomeTopCollectionsCarousel
    },
    data(){
        return {
            collectionItems: [],
            topCollectionItems: [],
            restCollectionsItems: []
        }
    },
    computed: {
        ...mapGetters({
            collectionsList: GOrders.GET_COLLECTIONS,
            topCollectionsList: GOrders.GET_TOP_COLLECTIONS,
            collectionsListLength: GOrders.GET_COLLECTIONS_LENGTH,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED
        }),
        topCollectionIds() {
            let _list = [];
            this.topCollectionsList.forEach(el => {
                _list.push(el.collectionId)
            });
            return _list
        }
    },
    methods: {
        scrollToAll() {
            this.$refs.allCollectionsRef.scrollIntoView({ behavior: 'smooth' });
        },
        scrollToTop() {
            this.$refs.topCollectionsRef.scrollIntoView({ behavior: 'smooth' });
        },
        getCollectionItems() {
            this.$store.dispatch(AOrders.GET_TOP_COLLECTIONS, this.$i18n.locale).then(() => {
                this.collectionItems = [];

                this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                    this.collectionItems = this.collectionsList;
                    this.topCollectionItems = [];
                    this.restCollectionsItems = [];

                    let homeCtrl = this;

                    this.collectionItems.forEach(item => {
                        if (homeCtrl.topCollectionIds.indexOf(item.id) > -1) {
                            homeCtrl.topCollectionItems.push(item)
                        }
                        if (homeCtrl.topCollectionIds.indexOf(item.id) < 0 && !item.isGiftDelivery) {
                            homeCtrl.restCollectionsItems.push(item)
                        }
                    })
                });
            })
        }
    },
    mounted() {
        this.getCollectionItems();

        this.$nuxt.$on('langUpdated', () => {
            this.getCollectionItems();
        })
    }
};
</script>

<style scoped>
.card-icon {
    height: 80px;
    width: 80px;
    margin: 0 auto 8px;
}
.card-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    margin-bottom: 8px;
    color: #004F7F;
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.card-text {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    font-weight: 400;
    color: #002840;
    font-size: 16px;
    font-style: normal;
    line-height: normal;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.padding120 {
    padding: 0 120px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}

.slogan {
    height: 792px;
    position: relative;
    background: linear-gradient(90deg, #00304D 21.74%, rgba(0, 48, 77, 0.00) 67.46%), url('../assets/landing/investor/hero-investor.png') no-repeat center;
    background-size: cover;
    margin-bottom: 197px;
}


/* START Top Collections */
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    margin-bottom: 16px;
    position: relative;
    color: #FFF;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.home-title2 {
    text-align: left;
}
.home-title span {
    color: #8CD0FA;
}
.home-subtitle {
    color: #FFF;
    text-align: center;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 40px;
}
.home-subtitle2 {
    text-align: left;
    margin-bottom: 0;
}
.home-collections-container {
    max-width: 1214px;
    margin: 0 auto;
}

.slogan-bullets {
    position: absolute;
    bottom: -107px;
    left: 0;
    right: 0;
}

/* END Top Collections */

.why-vindome-wrapper {
    margin-top: 40px;
}
.why-vindome-wrapper .row {
    margin: 0;
}
.how-icon {
    padding: 16px;
    border-radius: 16px;
    background: white;
    box-shadow: 0 4px 16px 0 rgba(0, 48, 77, 0.12);
}
.why-vindome-col {
    width: calc((100% - 80px) / 3);
    padding: 0;
}
.why-vindome-col-2 {
    margin: 0 40px;
}

#more-collections {
    background: linear-gradient(180deg, #8E8E8E 0%, #717172 100%), #F5F5F5;
}
#top-collections {
    background: linear-gradient(180deg, #45677B 0%, #00304D 100%);
}
#authenticity {
    position: relative;
    background: linear-gradient(90deg, #001D2F 32.43%, rgba(0, 29, 47, 0.00) 68.96%), url('../assets/landing/investor/hero-second.png'), lightgray 620px -291.803px / 67.708% 247.65% no-repeat;
    background-size: cover;
    background-position: center;
}
.auth-text-inner {
    max-width: 543px;
}
.more-collections-container {
    padding-bottom: 34px;
}
.hero-wrapper {
    display: flex;
    gap: 40px;
}
.hero-text-wrapper, .auth-text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
}
.hero-text-wrapper {
    padding-top: 132px;
}
.hero-title {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.hero-title div {
    color: #8CD0FA;
}
.hero-text {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 16px;
}
.hero-btn {
    color: white;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 16px;
    border-radius: 8px;
    border: 2px solid white;
    background:  rgba(255, 255, 255, 0.16);
    text-decoration: none;
}
.hero-btn:hover,
.home-section2-btn2:hover {
    cursor: pointer;
}
.investor5 {
    background: white;
}
.investor5 .container1366 {
    display: flex;
    align-items: center;
    gap: 40px;
}
.investor5-left, .investor5-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1 0 0;
}
.investor5-left {
    align-self: stretch;
    justify-content: flex-start;
}
.investor5-left-title {
    color: #3C789D;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    align-self: stretch;
    margin-bottom: 16px;
}
.investor5-left-title span {
    color: #004772;
}
.investor5-left-text {
    color: #002840;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    opacity: 0.8;
}
.investor5-left {
    background: url('../assets/landing/investor/sec5.png') no-repeat center bottom;
    background-size: 100%;
    position: relative;
}
.investor5-right-row1, .investor5-right-row2 {
    display: flex;
    align-items: center;
    align-self: stretch;
}
.investor5-right-item {
    display: flex;
    padding-bottom: 0;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
}
.investor5-right-item.item1 {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 24px;
    background: url('../assets/landing/investor/sec5-1.png') no-repeat left top;
    background-size: 80px;
    padding-top: 96px;
    padding-right: 24px;
}
.investor5-right-item.item2 {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-left: 24px;
    padding-bottom: 24px;
    background: url('../assets/landing/investor/sec5-2.png') no-repeat 24px top;
    background-size: 80px;
    padding-top: 96px;
}
.investor5-right-item.item3 {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    background: url('../assets/landing/investor/sec5-3.png') no-repeat left 24px;
    background-size: 80px;
    padding-top: 120px;
    padding-right: 24px;
}
.investor5-right-item.item4 {
    padding-left: 24px;
    background: url('../assets/landing/investor/sec5-4.png') no-repeat 24px 24px;
    background-size: 80px;
    padding-top: 120px;
}
.investor5-right-item-title {
    color: #004772;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    align-self: stretch;
}
.investor5-right-item-text {
    color: rgba(0, 0, 0, 0.64);
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    opacity: 0.8;
    align-self: stretch;
}
.investor5-right-item-text1 {
    opacity: 0.8;
    color: #3C789D;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    align-self: stretch;
}
.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    color: #FFFFFF;
    background: #004F7F;
    border-radius: 8px;
    padding: 14px 16px;
    height: 49px;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 17px;
    text-decoration: none;
    position: absolute;
    bottom: 0;
    border: 1px solid #004F7F;
    left: 0;
}
.home-section2-btn2:hover {
    background: transparent;
    color: #004F7F;
}

@media(width: 1024px) {
    .investor5-left {
        background-size: 412px 267px;
    }
    .padding120 {
        padding-left: 80px;
        padding-right: 80px;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        min-width: 455px;
    }
    #top-collections .container1366 {
        padding-left: 0;
        padding-right: 0;
    }
    .hero-wrapper, #authenticity .container1366 {
        padding-left: 80px;
        padding-right: 80px;
    }
}

@media(width: 768px) {
    .investor5-left-title {
        font-size: 22px;
    }
    .investor5-right-item-title {
        font-size: 18px;
    }
    .investor5-left-text,
    .investor5-right-item-text,
    .investor5-right-item-text1 {
        font-size: 14px;
    }
    .investor5-right-item.item1 {
        background-size: 40px;
        padding-top: 40px;
        padding-bottom: 10px;
    }
    .investor5-right-item.item2 {
        padding-top: 40px;
        padding-left: 16px;
        background: url('../assets/landing/investor/sec5-2.png') no-repeat 16px top;
        background-size: 40px;
        padding-bottom: 10px;
    }
    .investor5-right-item.item3 {
        background: url('../assets/landing/investor/sec5-3.png') no-repeat left 16px;
        background-size: 40px;
        padding-top: 56px;
    }
    .investor5-right-item.item4 {
        padding-left: 16px;
        background: url('../assets/landing/investor/sec5-4.png') no-repeat 16px 16px;
        background-size: 40px;
        padding-top: 56px;
    }
    .investor5-left {
        background-size: 270px 175px;
    }
    .padding120 {
        padding-left: 40px;
        padding-right: 40px;
    }
    .padding80 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    .hero-title {
        font-size: 32px;
    }
    .home-title {
        font-size: 22px;
    }
    .hero-text, .card-title {
        font-size: 18px;
    }
    .home-subtitle {
        font-size: 16px;
    }
    .card-text {
        font-size: 14px;
    }
    .hero-text-wrapper {
        padding-top: 28px;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        min-width: 377px;
    }
    .slogan {
        height: 515px;
        margin-bottom: 155px;
    }
    .why-vindome-col {
        width: calc((100% - 48px) / 3);
    }
    .why-vindome-col-2 {
        margin: 0 24px;
    }
    .how-icon {
        height: 228px;
    }
    .card-icon, .card-icon svg {
        height: 56px;
        width: 56px;
    }
    .hero-wrapper {
        padding-left: 48px;
        padding-right: 48px;
    }
    #authenticity .container1366 {
        padding-left: 40px;
        padding-right: 40px;
    }
    #authenticity {
        height: 208px;
    }
    .home-subtitle2 {
        font-size: 14px;
    }
    .auth-text-inner {
        max-width: 361px;
    }
}

@media(max-width: 767px) {
    .investor5 .padding80 {
        padding-top: 24px;
        padding-bottom: 24px;
        display: block;
    }
    .investor5-left {
        height: 217px;
        background-size: 258px 167px;
        margin-bottom: 16px;
    }
    .investor5-right {
        align-self: stretch;
    }
    .investor5-left-title {
        font-size: 22px;
        margin-bottom: 8px;
    }
    .investor5-right-item-title {
        font-size: 18px;
    }
    .investor5-left-text,
    .investor5-right-item-text,
    .investor5-right-item-text1 {
        font-size: 14px;
    }
    .investor5-right-item.item1 {
        background-size: 40px;
        padding-top: 40px;
        padding-bottom: 10px;
    }
    .investor5-right-item.item2 {
        padding-top: 40px;
        padding-left: 16px;
        background: url('../assets/landing/investor/sec5-2.png') no-repeat 16px top;
        background-size: 40px;
        padding-bottom: 10px;
    }
    .investor5-right-item.item3 {
        background: url('../assets/landing/investor/sec5-3.png') no-repeat left 16px;
        background-size: 40px;
        padding-top: 56px;
    }
    .investor5-right-item.item4 {
        padding-left: 16px;
        background: url('../assets/landing/investor/sec5-4.png') no-repeat 16px 16px;
        background-size: 40px;
        padding-top: 56px;
    }
    .why-vindome-col {
        width: 100%;
    }
    .why-vindome-col-2 {
        margin: 24px 0;
    }
    .padding120 {
        padding-left: 16px;
        padding-right: 16px;
    }
    .padding80 {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .hero-text-wrapper {
        display: none;
    }
    .hero-text-wrapper.hero-text-wrapper1 {
        display: flex;
        padding-top: 56px;
    }
    .hero-title {
        font-size: 40px;
    }
    .hero-text {
        font-size: 18px;
    }
    .slogan {
        height: auto;
        margin-bottom: 0;
        background: url('../assets/landing/investor/hero-investor.png') no-repeat center;
        background-size: 200% 646px;
        background-position: -67px 0;
    }
    .slogan-bullets {
        position: relative;
        bottom: 0;
        margin-top: 40px;
        margin-bottom: 16px;
    }
    .why-vindome-wrapper .row {
        display: block;
    }
    .hero-btn {
        display: inline-block;
        margin: 16px 0;
    }
    .home-title {
        font-size: 22px;
        margin-bottom: 8px;
    }
    .home-subtitle {
        font-size: 14px;
        margin-bottom: 16px;
    }
    #authenticity {
        height: 372px;
        background: linear-gradient(180deg, #001D2F 34.17%, rgba(0, 29, 47, 0.00) 49.89%), url('../assets/landing/investor/hero-second.png'), lightgray -139.778px 62.345px / 174.353% 100% no-repeat;
        background-size: 1350px;
        background-position: 70% bottom;
        background-position: 70% bottom;
        background-repeat: no-repeat;
    }
}
</style>
<style>
.collections-page-investors .v-main {
    padding-top: 80px !important;
}
.collections-page-investors #more-collections .investment-horizon-wrapper,
.collections-page-investors #more-collections .collection-item {
    background: white;
}
.collections-page-investors #more-collections .collection-item {
    width: calc((100% - 144px)/3);
    margin-right: 72px;
}
.collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
    margin-right: 0;
}
.collections-page-investors #more-collections .collection-subtitle,
.collections-page-investors #more-collections .collection-price-wrapper {
    padding: 0 8px 8px;
}

@media (width: 1024px) {
    .collections-page-investors #more-collections .collection-item {
        width: calc((100% - 48px)/3);
        margin-right: 24px;
        display: inline-block;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
}
@media (width: 768px) {
    .collections-page-investors #more-collections .collection-item {
        width: calc((100% - 40px)/2);
        margin-right: 40px;
        display: inline-block;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 40px;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(2n+0) {
        margin-right: 0;
    }
}
@media (max-width: 767px) {
    .collections-page-investors .vueperslides__bullets:not(.vueperslides__bullets--outside) {
        display: none;
    }
    .collections-page-investors #more-collections .collection-item {
        width: 100%;
        margin-right: 0;
    }
    .collections-page-investors #more-collections .collection-item:nth-child(2n+0),
    .collections-page-investors #more-collections .collection-item:nth-child(3n+0) {
        margin-right: 0;
    }
}
</style>
